import React from "react";
import MuiPaper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/styles";

const Paper = ({ children, style }) => {
  const classes = useStyles();

  return (
    <MuiPaper
      style={style}
      classes={classes}
    >
      {children}
    </MuiPaper>
  );
};

export default Paper;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "fit-content",
    padding: "0 1em 1em 1em",
  },
}));
